var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('dep-header',{attrs:{"title":"Home"},on:{"changed":_vm.tabChanged}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container planner-list"})])
}]

export { render, staticRenderFns }